export default "__VITE_ASSET__0cd6bb65__"